query GetDafAdminFeePeriods($page: Int, $limit: Int, $search: String) {
  dafAdminFeePeriods(page: $page, limit: $limit, search: $search) {
    collection {
      id
      name
      startDate
      endDate
      lockedDate
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
